import React, { memo, useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import Button from '../Button';

function SubTypePopup({
  closeDialog,
  subChildPrams,
  form = 'therapy',
  callBack,
}) {
  const [allData, setAllData] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(false);
  const [selectedArea, setSelectedArea] = useState('');
  const [checkboxValues, setCheckboxValues] = useState([]);
  const chkBoxId = subChildPrams[0];
  const childData = subChildPrams[1];

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openTcSubItemPopup',
          {
            schildId: childData?.child_id, //child id..
            form: form, //bpsi or therapy
          }
        );
        if (response.status === 200) {
          setAllData(response?.data?.childList);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [childData?.child_id, form]);

  const handleForm = () => {
    let str = childData?.child_texte + ': ';
    str = str.charAt(0).toUpperCase() + str.slice(1);
    if (selectedRadio) {
      str += selectedRadio;
    }

    const chkboxvalues = Object.values(checkboxValues)
      .filter((value) => !!value)
      .join(', ');

    if (chkboxvalues) {
      str += chkboxvalues;
    }

    if (str) {
      if (selectedArea) {
        str += '\nNote: ' + selectedArea;
      }
    } else {
      if (selectedArea) {
        str += 'Note: ' + selectedArea;
      }
    }
    callBack(chkBoxId, str);
    closeDialog();
  };

  function handleCheckboxChange(event) {
    const { name, checked } = event.target;
    if (checked) {
      setCheckboxValues((prevState) => ({
        ...prevState,
        [name]: name.split('_')[0],
      }));
    } else {
      setCheckboxValues((prevState) => ({
        ...prevState,
        [name]: false,
      }));
    }
  }

  return (
    <div className="modalBackground" style={{ zIndex: '30' }}>
      <div
        className="form-add-values-main-con grid-sec"
        style={{ backgroundColor: '#fff' }}
      >
        <div className="form-add-values-hdr flex-sec">
          <div className="hdr-pt-info">
            Select values: {childData?.child_texte}
          </div>
          <Button variant="circle" onClick={closeDialog}>
            x
          </Button>
        </div>
        <div className="form-add-values-bdy grid-sec">
          {allData &&
            allData.map((data, i) => {
              return (
                <div
                  key={i}
                  className={
                    i % 2 === 0
                      ? `form-add-values-bdy-rw flex-sec`
                      : 'form-add-values-bdy-rw flex-sec alt-rw'
                  }
                >
                  <span className="form-add-values-type">
                    {(data?.inputType === 'radio' && (
                      <input
                        type="radio"
                        value={data?.itemName || ''}
                        checked={selectedRadio === data?.itemName}
                        onChange={(e) => setSelectedRadio(e.target.value)}
                        id={`${data?.itemName}_${data?.itemId}`}
                      />
                    )) ||
                      (data?.inputType === 'checkbox' && (
                        <input
                          type="checkbox"
                          name={`${data?.itemName}_${data?.itemId}`}
                          checked={
                            (checkboxValues &&
                              checkboxValues[
                                `${data?.itemName}_${data?.itemId}`
                              ]) ||
                            false
                          }
                          onChange={handleCheckboxChange}
                          id={`${data?.itemName}_${data?.itemId}`}
                        />
                      ))}
                  </span>
                  <label
                    htmlFor={`${data?.itemName}_${data?.itemId}`}
                    className="form-add-values-val"
                  >
                    {data?.itemName}
                  </label>
                </div>
              );
            })}

          <div className="form-add-values-bdy-rw flex-sec  alt-rw">
            <span className="form-add-values-type">Note:</span>
            <span className="form-add-values-val">
              {/* <div
                contentEditable="true"
                className="add-values-txtarea"
                onBlur={(e) => setSelectedArea(e.target.innerHTML)}
                dangerouslySetInnerHTML={{ __html: selectedArea || '' }}
                style={{
                  display: 'inline-block',
                  border: '1px solid #ccc',
                  padding: '5px',
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  height: '100px',
                }}
              /> */}
              <textarea
                className="add-values-txtarea"
                onChange={(e) => setSelectedArea(e.target.value)}
                value={selectedArea || ''}
              ></textarea>
            </span>
          </div>
        </div>
        <div className="comp-msg-ftr flex-sec">
          <Button
            variant="default"
            onClick={closeDialog}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleForm}>
            Record
          </Button>
        </div>
      </div>
    </div>
  );
}

export default memo(SubTypePopup);
